// extracted by mini-css-extract-plugin
export default {"Welcome":"style_Welcome__ZvysN","scroll":"style_scroll__PgRqk","Welcome__textCon":"style_Welcome__textCon__-Tb3r","viewBtn":"style_viewBtn__31OvQ"};